import React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import {
  BooleanField,
  Datagrid,
  EditButton,
  FilterList,
  FilterListItem,
  FilterLiveSearch,
  FunctionField,
  List,
  TextField,
  useRecordContext,
  useUpdate,
} from "react-admin";
import { Button } from "@mui/material";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import VerifiedIcon from "@mui/icons-material/Verified";

const operationLabel = (op) => {
  const labels = {
    add: "Add (+)",
    subtract: "Subtract (-)",
    multiply: "Multiply (×)",
    set: "Set Ratio (=)",
    set_price_to: "Set Price (=)",
    foxcub_override: "Foxcub Override",
  };
  return labels[op] ?? "—";
};

const ActiveFilter = () => (
  <FilterList label="Status">
    <FilterListItem label="Active" value={{ active: true }} />
    <FilterListItem label="Inactive" value={{ active: false }} />
  </FilterList>
);

const FilterSidebar = () => (
  <Card>
    <CardContent>
      <FilterLiveSearch label="Search Rule Name" source="name" />
      <ActiveFilter />
    </CardContent>
  </Card>
);

const ToggleActiveButton = () => {
  const record = useRecordContext();
  const [update, { isPending }] = useUpdate();

  if (!record) return null;

  const handleToggle = (e) => {
    e.stopPropagation();
    update("ml-pricing-rules", {
      id: record.id,
      data: { active: !record.active },
      previousData: record,
    });
  };

  return (
    <Button
      size="small"
      variant={record.active ? "contained" : "outlined"}
      color={record.active ? "success" : "inherit"}
      startIcon={<PowerSettingsNewIcon />}
      onClick={handleToggle}
      disabled={isPending}
    >
      {record.active ? "Enabled" : "Disabled"}
    </Button>
  );
};

const VerifyButton = () => {
  return (
    <Button
      size="small"
      variant="outlined"
      color="info"
      startIcon={<VerifiedIcon />}
    >
      Verify
    </Button>
  );
};

const ListMlPricingRules = (props) => {
  return (
    <CardContent>
      <Typography typography="h4" component="h1" mb={2}>
        ML Pricing Rules
      </Typography>
      <List
        {...props}
        exporter={false}
        aside={<FilterSidebar />}
        filters={<React.Fragment></React.Fragment>}
        sort={{ field: "sortOrder", order: "ASC" }}
      >
        <Datagrid bulkActionButtons={false}>
          <TextField source="name" label="Rule Name" />
          <TextField source="sortOrder" label="Order" />
          <TextField source="matchType" label="Match Type" />
          <FunctionField
            label="Low"
            render={(r) =>
              r.lowOperation
                ? `${operationLabel(r.lowOperation)} ${r.lowValue}`
                : "—"
            }
          />
          <FunctionField
            label="Medium"
            render={(r) =>
              r.mediumOperation
                ? `${operationLabel(r.mediumOperation)} ${r.mediumValue}`
                : "—"
            }
          />
          <FunctionField
            label="High"
            render={(r) =>
              r.highOperation
                ? `${operationLabel(r.highOperation)} ${r.highValue}`
                : "—"
            }
          />
          <BooleanField source="active" label="Active" />
          <ToggleActiveButton />
          <VerifyButton />
          <EditButton />
        </Datagrid>
      </List>
    </CardContent>
  );
};

export default ListMlPricingRules;
